import EfScrollAni from '@/efscrollani';
import A from '../../comps/A';
import B from '../../comps/B';
import C2 from '../../comps/C2';
// import D from '../../comps/D';
import E from '../../comps/E';
import F from '../../comps/F';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import J from '../../comps/J';
import K from '../../comps/K';
import L from '../../comps/L';
import M from '../../comps/M';
import O from '../../comps/O';
import P from '../../comps/P';
import N from '../../comps/N';
import VS from '../../comps/VS';
import FooterTcA from '../../comps/FooterTcA';
import css from './index.module.scss';
import { useRouter } from 'next/router';
// import dynamic from 'next/dynamic';
// const N = dynamic(() => import('../../comps/N'));

const Overview: React.FC = () => {
    const { locale = '' } = useRouter();
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`rapid-pro-overview ${css.page}`}>
            <A />
            <B />
            <C2 />

            {/* <D />
            <E /> */}
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            {locale === 'us' && <M />}
            {locale === 'us' && <N />}
            {locale === 'us' && <O />}
            <P />

            <VS />

            <FooterTcA />
        </div>
    );
};

export default Overview;
